import { AccordionSection } from "../../components/types";

export const accordionFeatureSections: AccordionSection[] = [
  {
    title: "Providers",
    isExpanded: true,
    description:
      "Verse works with 9 of the top 10 health systems by revenue to manage DME ordering.",
    subtitle: "Why providers love Verse",
    bulletPoints: [
      { text: "Verse fits into prescribers' existing workflow." },
      { text: "Real-time coverage validation eliminates back and forth" },
      { text: "Tracking & transparency for orders." },
      { text: "AI-driven medical record validation." },
      {
        text: "No integration required on day one, but can integrate with every major EMR.",
      },
    ],
  },
  {
    title: "Payors",
    description:
      "Verse works with payors to eliminate fraud, waste & abuse while enhancing provider & member experience.",
    subtitle: "Why payors adopt Verse",
    bulletPoints: [
      {
        text: "Prescriber adoption: Clinicians in health systems across the country already love working with Verse, making deployment easy.",
      },
      {
        text: "Verse can fulfill orders across all DME categories.",
        subBulletPoints: [
          {
            textAccent: "Payment Integrity:",
            text: "Verse minimizes overpayment and out-of-policy spend for payor partners",
          },
          {
            textAccent: "Coverage Validation:",
            text: "Verse ingests coverage rules and enforces them throughout the ordering workflow.",
          },
        ],
      },
      {
        text: "Medical Record Validation: Verse is the only DME provider using AI to validate medical necessity down to the medical record.",
      },
    ],
    isExpanded: false,
  },
  {
    title: "Patients",
    description: "Get DME on-time, every time.",
    subtitle: "Why patients love Verse",
    bulletPoints: [
      {
        text: "Text updates & tracking. Patients have clarity & peace of mind for every order.",
      },
      {
        text: "Easy refill & resupply management. Patients can easily initiate refills and Verse will manage coordination with their provider.",
      },
      {
        textAccent: "(Coming Soon)",
        text: "Patient-facing portal. Patients can go beyond phone & text to manage their DME needs.",
      },
    ],
    isExpanded: false,
  },
];
